import {Observable} from 'rxjs'
import {TranslocoService} from '@ngneat/transloco'
import {map} from 'rxjs/operators'

export function tryTranslatingKey(i18n: TranslocoService, key: string): Observable<string | undefined> {
  return i18n.selectTranslate(key).pipe(map(x => (x !== key ? x : undefined)))
}
